var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixReviewsV1Review from '@wix/ambassador-reviews-v1-review/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
/** Supported types of review author. */
export var AuthorType;
(function (AuthorType) {
    AuthorType["UNKNOWN"] = "UNKNOWN";
    AuthorType["MEMBER"] = "MEMBER";
    AuthorType["VISITOR"] = "VISITOR";
})(AuthorType || (AuthorType = {}));
/** Supported states of the review. */
export var ModerationModerationStatus;
(function (ModerationModerationStatus) {
    ModerationModerationStatus["UNKNOWN"] = "UNKNOWN";
    ModerationModerationStatus["APPROVED"] = "APPROVED";
    ModerationModerationStatus["IN_MODERATION"] = "IN_MODERATION";
    ModerationModerationStatus["REJECTED"] = "REJECTED";
    ModerationModerationStatus["SUBMITTED"] = "SUBMITTED";
})(ModerationModerationStatus || (ModerationModerationStatus = {}));
/** Supported types of review origin. */
export var OriginType;
(function (OriginType) {
    /** Indicates that the review origin is unknown. */
    OriginType["UNKNOWN"] = "UNKNOWN";
    /** Indicates that the review was created organically. */
    OriginType["ORGANIC"] = "ORGANIC";
    /** Indicates that the review was created by an application. */
    OriginType["APP"] = "APP";
})(OriginType || (OriginType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var UpdateModerationStatusRequestModerationStatus;
(function (UpdateModerationStatusRequestModerationStatus) {
    UpdateModerationStatusRequestModerationStatus["UNKNOWN_MODERATION_STATUS"] = "UNKNOWN_MODERATION_STATUS";
    UpdateModerationStatusRequestModerationStatus["APPROVED"] = "APPROVED";
    UpdateModerationStatusRequestModerationStatus["REJECTED"] = "REJECTED";
})(UpdateModerationStatusRequestModerationStatus || (UpdateModerationStatusRequestModerationStatus = {}));
export var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus["UNKNOWN"] = "UNKNOWN";
    ModerationStatus["APPROVED"] = "APPROVED";
    ModerationStatus["REJECTED"] = "REJECTED";
})(ModerationStatus || (ModerationStatus = {}));
const _bulkCreateReviewRequest = { reviews: '_review' };
const _bulkCreateReviewResponse = { results: '_bulkReviewResult' };
const _bulkDeleteReviewsRequest = {};
const _bulkDeleteReviewsResponse = {};
const _bulkReviewResult = { review: '_review' };
const _bulkUpdateModerationStatusRequest = {};
const _bulkUpdateModerationStatusResponse = {};
const _countReviewsRequest = {};
const _countReviewsResponse = {};
const _createReviewAndContactRequest = { content: '_reviewContent' };
const _createReviewRequest = { review: '_review' };
const _createReviewResponse = { review: '_review' };
const _deleteReviewRequest = {};
const _deleteReviewResponse = { review: '_review' };
const _getDeletedReviewRequest = {};
const _getDeletedReviewResponse = { review: '_review' };
const _getReviewRequest = {};
const _getReviewResponse = { review: '_review' };
const _media = { image: 'wix.common.Image', video: 'wix.common.VideoV2' };
const _queryReviewsRequest = {};
const _queryReviewsResponse = { results: '_review', reviews: '_review' };
const _removeReplyRequest = {};
const _removeReplyResponse = { review: '_review' };
const _review = { content: '_reviewContent' };
const _reviewContent = { media: '_media' };
const _setReplyRequest = {};
const _setReplyResponse = { review: '_review' };
const _updateModerationStatusRequest = {};
const _updateModerationStatusResponse = { review: '_review' };
const _updateReviewContentRequest = { content: '_reviewContent' };
const _updateReviewContentResponse = { review: '_review' };
const _updateReviewRequest = { review: '_review' };
const _updateReviewResponse = { review: '_review' };
/**
 * Retrieves a review.
 *
 *
 * The `getReview()` function returns a Promise that resolves to the retrieved review.
 *
 * By default, an unpublished review is not returned. To retrieve an unpublished review, pass `returnPrivateReviews` as `true`.
 * @param reviewId - Review ID.
 * @public
 * @documentationMaturity preview
 * @requiredField reviewId
 * @param options - Information about the reviews to retrieve.
 * @returns Review.
 */
export function getReview(reviewId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reviewId: '$[0]',
            returnPrivateReviews: '$[1].returnPrivateReviews',
        };
        const responseTransformation = '$.review';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getReviewRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getReviewResponse,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reviewId, options]);
        const reqOpts = ambassadorWixReviewsV1Review.getReview(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reviewId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves reviews from trash bin.
 * @param reviewId - Review ID.
 * @internal
 * @documentationMaturity preview
 * @requiredField reviewId
 * @adminMethod
 */
export function getDeletedReview(reviewId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { reviewId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getDeletedReviewRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getDeletedReviewResponse,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reviewId]);
        const reqOpts = ambassadorWixReviewsV1Review.getDeletedReview(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reviewId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a new review and a new contact.
 *
 *
 * When the review author is not a contact, use this endpoint. Include `name` and `email`,
 * as they're required to create the contact. If these parameters are missing, a new contact and
 * review won't be created.
 *
 * When the review author is already a contact, use either this endpoint or [Create Review](https://dev.wix.com/api/rest/reviews/create-review).
 * A new review is created but a new contact is not created. For a 3rd-party app, include `name` and `email`.
 *
 * After a review is created, it may require [moderation](https://dev.wix.com/api/rest/reviews/introduction#reviews_introduction_moderation).
 * @param namespace - Namespace where the review is created.
 * @param entityId - ID of the entity to review.
 * @param content - Review content.
 * @public
 * @documentationMaturity preview
 * @requiredField content
 * @requiredField content.rating
 * @requiredField entityId
 * @requiredField namespace
 * @deprecated
 * @replacedBy com.wixpress.critique.reviews.CreateReview
 * @targetRemovalDate 2024-02-01
 */
export function createReviewAndContact(namespace, entityId, content, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            namespace: '$[0]',
            entityId: '$[1]',
            content: '$[2]',
            name: '$[3].name',
            email: '$[3].email',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[4];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createReviewAndContactRequest,
            depSchemas: { _media, _reviewContent },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createReviewResponse,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([namespace, entityId, content, options]);
        const reqOpts = ambassadorWixReviewsV1Review.createReviewAndContact(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'namespace',
                'entityId',
                'content',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a review.
 *
 *
 * The `createReview()` function returns a promise that resolves to the created review.
 *
 * This function requires a `contactId`.
 *
 * If the review author does not have a contact ID, use `createReviewAndContact()`.
 *
 * If `authorName` is left empty, the member's name will be used. If the author is not a member, the field is left `null`.
 * @param review - Review data.
 * @public
 * @documentationMaturity preview
 * @requiredField review
 * @requiredField review.author
 * @requiredField review.author.contactId
 * @requiredField review.content
 * @requiredField review.content.rating
 * @requiredField review.entityId
 * @requiredField review.namespace
 * @returns Created review.
 */
export function createReview(review) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { review: '$[0]' };
        const responseTransformation = '$.review';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createReviewRequest,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createReviewResponse,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([review]);
        const reqOpts = ambassadorWixReviewsV1Review.createReview(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'review',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Create Bulk Reviews.
 * @param reviews - Reviews to create.
 * @internal
 * @documentationMaturity preview
 * @requiredField reviews
 * @requiredField reviews.author
 * @requiredField reviews.author.contactId
 * @requiredField reviews.content
 * @requiredField reviews.entityId
 * @requiredField reviews.namespace
 * @adminMethod
 */
export function bulkCreateReview(reviews, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reviews: '$[0]',
            returnEntity: '$[1].returnEntity',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkCreateReviewRequest,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['Array#reviews']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkCreateReviewResponse,
            depSchemas: { _bulkReviewResult, _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['Array#results.review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reviews, options]);
        const reqOpts = ambassadorWixReviewsV1Review.bulkCreateReview(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reviews',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates review content with provided data
 * @param reviewId - Review ID.
 * @public
 * @documentationMaturity preview
 * @requiredField reviewId
 * @param options - Options to use when creating a review and contact.
 * @adminMethod
 * @deprecated
 * @replacedBy com.wixpress.critique.reviews.UpdateReview
 * @targetRemovalDate 2024-07-31
 */
export function updateReviewContent(reviewId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            reviewId: '$[0]',
            content: '$[1].content',
            fieldMask: '$[1].fieldMask',
            mask: '$[1].mask',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateReviewContentRequest,
            depSchemas: { _media, _reviewContent },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateReviewContentResponse,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reviewId, options]);
        const reqOpts = ambassadorWixReviewsV1Review.updateReviewContent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reviewId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a review.
 *
 *
 * The `updateReview()` function returns a promise that resolves to the updated review.
 *
 * Each time the review is updated, `revision` increments by 1. The existing `revision` must be included
 * when updating the review. This ensures you're working with the latest review information, and it prevents unintended overwrites.
 *
 * This function is not a universal function and runs only on the backend.
 * @param _id - Review ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField review
 * @requiredField review.revision
 * @param options - Options to use when updating a review.
 * @param review - Review to update.
 * @adminMethod
 * @returns Updated review data.
 */
export function updateReview(_id, review, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            review: { '*': '$[1]', id: '$[0]' },
            fieldMask: '$[2].fieldMask',
        };
        const responseTransformation = '$.review';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateReviewRequest,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateReviewResponse,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, review, options]);
        const reqOpts = ambassadorWixReviewsV1Review.updateReview(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'review',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a review.
 *
 *
 * The `deleteReview()` function returns a promise that resolves to the deleted review.
 * @param reviewId - Review ID.
 * @public
 * @documentationMaturity preview
 * @requiredField reviewId
 * @adminMethod
 */
export function deleteReview(reviewId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { reviewId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteReviewRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteReviewResponse,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reviewId]);
        const reqOpts = ambassadorWixReviewsV1Review.deleteReview(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reviewId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes multiple reviews.
 *
 *
 * The `bulkDeleteReviews()` function returns a promise which resolves to the `jobId`. The `jobId` is a unique ID that can be used to refer to that specific bulk delete.
 *
 * All reviews that meet the specified filter criteria are deleted. To perform a dry run, use the intended filter options with `queryReviews()`.
 *
 * When this function is used, a bulk job is started and `jobId` is returned. The job might not complete right away, depending on its size.
 * @public
 * @documentationMaturity preview
 * @param options - Information about the reviews to delete.
 * @adminMethod
 */
export function bulkDeleteReviews(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0].filter' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkDeleteReviewsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkDeleteReviewsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixReviewsV1Review.bulkDeleteReviews(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a query to retrieve a list of reviews.
 *
 *
 * The `queryReviews()` function builds a query to retrieve a list of reviews and returns a `ReviewsQueryBuilder` object.
 *
 * The returned object contains the query definition, which is typically used to run the query using the  `find()` function.
 *
 * You can refine the query by chaining `ReviewsQueryBuilder` functions onto the query.
 *
 * `ReviewsQueryBuilder` functions enable you to sort, filter,
 * and control the results that `queryReviews()` returns.
 *
 * The `queryReviews()` function runs with the following defaults, which you can override:
 *
 * - `ascending("_createdDate")`
 * - `limit(100)`
 *
 * The functions that are chained to `queryReviews()` are applied in the order they're called. For example, if you apply `descending("_createdDate")` and then `descending("content.rating")`, the results are sorted first by the `_createdDate`, and then, if there are multiple results with the same `_createdDate`, the items are sorted by `content.rating`.
 * @public
 * @documentationMaturity preview
 * @param options - Information about the reviews to retrieve.
 */
export function queryReviews(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.reviews',
        pagingMetadata: '$.metadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryReviewsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryReviewsResponse,
        depSchemas: { _media, _review, _reviewContent },
        fqdnTransformation: {
            paths: [...['Array#results', 'Array#reviews']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixReviewsV1Review.queryReviews(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Set reply on a review
 * @param reviewId - Review id
 * @param message - Response to review author
 * @public
 * @documentationMaturity preview
 * @requiredField message
 * @requiredField reviewId
 * @adminMethod
 */
export function setReply(reviewId, message) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { reviewId: '$[0]', message: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _setReplyRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _setReplyResponse,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reviewId, message]);
        const reqOpts = ambassadorWixReviewsV1Review.setReply(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reviewId',
                'message',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Removes reply from review
 * @param reviewId - Review ID
 * @public
 * @documentationMaturity preview
 * @requiredField reviewId
 * @adminMethod
 */
export function removeReply(reviewId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { reviewId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _removeReplyRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _removeReplyResponse,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reviewId]);
        const reqOpts = ambassadorWixReviewsV1Review.removeReply(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reviewId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates the moderation status of a review.
 *
 * Possible moderation statuses:
 * -  APPROVED: The review is published and viewable by site visitors.
 * -  REJECTED: The review is declined and not viewable by site visitors.
 * @param reviewId - Review id
 * @internal
 * @documentationMaturity preview
 * @requiredField reviewId
 * @adminMethod
 */
export function updateModerationStatus(reviewId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { reviewId: '$[0]', status: '$[1].status' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateModerationStatusRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateModerationStatusResponse,
            depSchemas: { _media, _review, _reviewContent },
            fqdnTransformation: {
                paths: [...['review']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([reviewId, options]);
        const reqOpts = ambassadorWixReviewsV1Review.updateModerationStatus(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'reviewId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Changes moderation status for multiple reviews
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function bulkUpdateModerationStatus(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            filter: '$[0].filter',
            status: '$[0].status',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkUpdateModerationStatusRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkUpdateModerationStatusResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixReviewsV1Review.bulkUpdateModerationStatus(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @public
 * @documentationMaturity preview
 */
export function countReviews(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            filter: '$[0].filter',
            includePrivateReviews: '$[0].includePrivateReviews',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countReviewsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countReviewsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixReviewsV1Review.countReviews(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=reviews-v1-review.universal.js.map